import { Component, Injector, Input, OnInit } from '@angular/core';
import { ApAlertService , ApBaseModalComponent } from 'webcommon/core-ui';

@Component({
  selector: 'ap-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.less'],
  providers: [ApAlertService]
})
export class DeleteModalComponent extends ApBaseModalComponent<boolean | null> implements OnInit {
  @Input() title: string;
  constructor(
    elementInjector: Injector
  ) {
    super(elementInjector);
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  cancel(): void {
    this.closeModal(null);
  }

  onOk(): void {
    this.closeModal(true);
  }

}
